// extracted by mini-css-extract-plugin
module.exports = {"dataVisIframe":"_00b99a6"};